import script from "./orderDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./orderDetailModal.vue?vue&type=style&index=0&id=37c32f06&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c32f06"]])

export default __exports__